import type { Geometry } from '@/@types/gtfs-ressource';
import type { StopType } from './trip-updates';
import type { VehicleReport, VehicleTrack } from '@pysae/transit-core/vehicle-placement';

export enum MapZoomLevel {
  STOPS = 'stops',
  STATIONS = 'stations',
  TERMINUS = 'terminus',
}

/** Order in which stop names are placed on the map; the lower, the sooner a name gets its spot. */
export const MapLabelPriority = {
  SELECTED: 0,
  ARRIVAL: 1,
  DEPARTURE: 2,
  DEFAULT: 100,
} as const;

export interface MapLngLat {
  lng: number;
  lat: number;
}
export interface MapRessourceClicked {
  stopId?: string;
  vehicleId?: string;
  routeId?: string;
}

export interface MapShape {
  geometry: Geometry;
  properties: {
    routeId: string | undefined;
    color: string;
  };
}

export interface MapStop {
  id: string;
  name: string;
  position: MapLngLat;
  parentStation: string;
  /**
   * Arrival of the trip shown, or either end of the route shown: drawn as a pin,
   * with its name on a card above it.
   */
  terminus: boolean;
  zoomLevel: {
    stops?: boolean;
    stations?: boolean;
    terminus?: boolean;
  };
  children: Array<string>;
  type?: StopType;
  /** `MapLabelPriority`, when the stop deserves its name over its neighbours'. */
  labelPriority?: number;
}

export interface MapVehicle {
  id: string;
  position: MapLngLat;
  /** Undefined while the heading is unknown: the vehicle is drawn without its arrow. */
  bearing?: number;
  color: string;
  selected: boolean;
  /** Absent: the vehicle is drawn at its raw position, without animation. */
  animation?: { report: VehicleReport; track: VehicleTrack };
  /** A last known position, dimmed: the realtime feed no longer answers. */
  stale?: boolean;
}
